// src/graph/organisation/types.ts
var GraphOrganisationAriResourceOwner = "graph", GraphOrganisationAriResourceType = "organisation";

export {
  GraphOrganisationAriResourceOwner,
  GraphOrganisationAriResourceType
};
